export const environment = {
    version: '0.0.1-testing',
    production: false,
    envName: 'testing',
    http_request_timeout: 120000,
    appName: 'Virtual Assistant Docenti backend',
    defaultLanguage: 'it',
    samlProviderName: 'vatutor-external-idp',
    apiUrl: '.',
    apiV1: '/api/v1.0',
    endpoint: "https://api.vatutor.assistant.beta80group.it",
    documentiApi: '/document',
    samlEnabled: true,
    chatConfig: {
        useRemoteLoader: true,
        remoteTestUrl: 'https://d7cthvl7iswez.cloudfront.net/bundle/vatutor-chat.bundle.js',
        remoteProdUrl: 'https://d1xczn31atzw9f.cloudfront.net/bundle/vatutor-chat.bundle.js',
        bundleFile: 'vatutor-chat.bundle.js',
        elementTag: 'vatutor-chat',
    },
    amplifyConfig: {
        samlAuth: {
            region: 'eu-central-1',
            userPoolId: 'eu-central-1_cnQ9xSzjJ',
            userPoolWebClientId: '2bi6d3bmgfr44dla81j8rumiep',
            mandatorySignIn: false,
            authenticationFlowType: 'USER_SRP_AUTH',
            customCinecaLogoutUrl: 'https://lumsa.idp.pp.cineca.it/idp/profile/Logout',
            oauth: {
                domain: 'eu-central-1cnq9xszjj.auth.eu-central-1.amazoncognito.com',
                scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'profile'],
                redirectSignIn: 'https://vatutor.assistant.beta80group.it/',
                redirectSignOut: 'https://vatutor.assistant.beta80group.it/logout-handler',
                responseType: 'code',
            },
        },
        // Configurazione per l'autenticazione nativa
        nativeAuth: {
            region: 'eu-central-1',
            userPoolId: 'eu-central-1_cnQ9xSzjJ',
            userPoolWebClientId: '3jfmjrskkjnt3qper9v5q4mdss',
            mandatorySignIn: false,
            authenticationFlowType: 'USER_PASSWORD_AUTH',
            oauth: {
                domain: 'eu-central-1cnq9xszjj.auth.eu-central-1.amazoncognito.com',
                scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'profile'],
                redirectSignIn: 'https://vatutor.assistant.beta80group.it/',
                redirectSignOut: 'https://vatutor.assistant.beta80group.it/login-admin',
                responseType: 'code',
            },
        },
    },
};
